import withStyles from "isomorphic-style-loader/withStyles";
import React, { ReactNode } from "react";
import styles from "../../styles.scss";
import { Tooltip } from "@mui/material";
import { Label } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

interface SectionLabelProps {
  label: string;
  subtitle?: string;
  tooltip?: string;
  children?: ReactNode;
}

const SectionLabel = ({
  label,
  subtitle,
  tooltip,
  children,
}: SectionLabelProps) => {
  return (
    <>
      <Label
        className={styles.sectionLabel}
        style={{
          display: "flex",
          justifyContent: children ? "space-between" : "normal",
        }}
      >
        {label}{" "}
        {tooltip && (
          <Tooltip title={tooltip}>
            <FontAwesomeIcon
              icon={faExclamationCircle}
              className={styles.infoIcon}
            />
          </Tooltip>
        )}
        {children}
      </Label>
      {subtitle && <p className={styles.helperText}>{subtitle}</p>}
    </>
  );
};

export default withStyles(styles)(SectionLabel);
